var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{attrs:{"dense":""}},_vm._l((_setup.items),function(e,i){return _c('v-col',{key:i,attrs:{"cols":"auto"}},[_c('v-chip',{attrs:{"color":e.valid.color,"text-color":"white"}},[_vm._v(" "+_vm._s(e.text)+" ")])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }